import { render, staticRenderFns } from "./CountdownLiveClass.vue?vue&type=template&id=5fd47bed&scoped=true"
import script from "./CountdownLiveClass.vue?vue&type=script&lang=js"
export * from "./CountdownLiveClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd47bed",
  null
  
)

export default component.exports